import request from '@/utils/request'

export function allEventStatistics(pv) {
  return request({
    url: '/event/allEventStatistics?tenantInfoId=' + pv.replaceAll("\"", ""),
    method: 'get'
  })
}

export function mapList(pv) {
  return request({
    url: '/robot/mapList?tenantInfoId=' + pv.replaceAll("\"", ""),
    method: 'get'
  })
}

export function robotList(pv) {
  return request({
    url: '/robot/robotList?tenantInfoId=' + pv.replaceAll("\"", ""),
    method: 'get'
  })
}

export function eventList(pv) {
  return request({
    url: '/event/eventList?tenantInfoId=' + pv.replaceAll("\"", ""),
    method: 'get'
  })
}

export function robotNum(pv) {
  return request({
    url: 'robot/robotNum?tenantInfoId=' + pv.replaceAll("\"", ""),
    method: 'get'
  })
}

export function eventChart(pv) {
  return request({
    url: '/event/eventChart?tenantInfoId=' + pv.replaceAll("\"", ""),
    method: 'get'
  })
}

export function mapEventChart(pv) {
  return request({
    url: '/event/mapEventChart?tenantInfoId=' + pv.replaceAll("\"", ""),
    method: 'get'
  })
}

export function mapEventLineChart(pv) {
  return request({
    url: '/event/mapEventLineChart?tenantInfoId=' + pv.replaceAll("\"", ""),
    method: 'get'
  })
}

export function eventLineChart(pv) {
  return request({
    url: '/event/eventLineChart?tenantInfoId=' + pv.replaceAll("\"", ""),
    method: 'get'
  })
}

export function maintainMonthChart(pv) {
  return request({
    url: '/event/maintainMonthChart?tenantInfoId=' + pv.replaceAll("\"", ""),
    method: 'get'
  })
}

export function maintainYearChart(pv) {
  return request({
    url: '/event/maintainYearChart?tenantInfoId=' + pv.replaceAll("\"", ""),
    method: 'get'
  })
}

export function handleTime(pv) {
  return request({
    url: '/event/handleTime?tenantInfoId=' + pv.replaceAll("\"", ""),
    method: 'get'
  })
}

export function positonList(pv) {
  return request({
    url: '/robot/positonList ',
    method: 'post',
    data: { ...pv }
  })
}

export function rIndex(pv) {
  return request({
    url: '/rIndex ',
    method: 'get'
  })
}

export function runTime(pv) {
  return request({
    url: '/screen/runTime?tenantInfoId=' + pv.replaceAll("\"", ""),
    method: 'get'
  })
}

export function runMileage(pv) {
  return request({
    url: '/screen/runMileage?tenantInfoId=' + pv.replaceAll("\"", ""),
    method: 'get'
  })
}




// WEBPACK FOOTER //
// ./src/api/index.js